import { Link } from 'react-router-dom';

export const Footer: React.FC = () => {
  return (
    <footer className="footer-component w-full border-t border-border bg-background pt-16 pb-8">
      <div className="max-w-[1200px] mx-auto px-4 flex flex-col gap-10">
        <div className="flex flex-col md:flex-row justify-between gap-10">
          <div className="flex flex-col gap-4 max-w-[300px]">
            <div className="flex items-center gap-2 text-foreground">
              <img
                src="/logo.svg"
                alt="tuval.space logo"
                className="w-8 h-8"
              />
              <span className="text-xl font-bold">tuval.space</span>
            </div>
            <p className="text-muted-foreground text-sm">
              A collaborative canvas where you can have fun with others or use
              as your personal creative space. Create together, one pixel at a
              time.
            </p>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-10 sm:gap-16">
            <div className="flex flex-col gap-3">
              <h4 className="font-bold text-foreground">Platform</h4>
              <a
                className="text-muted-foreground hover:text-primary text-sm"
                href="#canvas"
              >
                Canvas
              </a>
              <a
                className="text-slate-400 hover:text-primary text-sm"
                href="#leaderboard"
              >
                Leaderboard
              </a>
              <a
                className="text-slate-400 hover:text-primary text-sm"
                href="#factions"
              >
                Factions
              </a>
            </div>
            <div className="flex flex-col gap-3">
              <h4 className="font-bold text-foreground">Community</h4>
              <a
                className="text-slate-400 hover:text-primary text-sm"
                href="#discord"
              >
                Discord
              </a>
              <a
                className="text-slate-400 hover:text-primary text-sm"
                href="#reddit"
              >
                Reddit
              </a>
            </div>
            <div className="flex flex-col gap-3">
              <h4 className="font-bold text-foreground">Legal</h4>
              <Link
                to="/terms"
                className="text-slate-400 hover:text-primary text-sm"
              >
                Terms
              </Link>
              <Link
                to="/privacy"
                className="text-slate-400 hover:text-primary text-sm"
              >
                Privacy
              </Link>
              <Link
                to="/guidelines"
                className="text-slate-400 hover:text-primary text-sm"
              >
                Guidelines
              </Link>
            </div>
          </div>
        </div>
        <div className="pt-8 border-t border-border flex flex-col sm:flex-row justify-between items-center gap-4 text-sm text-muted-foreground">
          <p>© 2026 tuval.space. All rights reserved.</p>
          <div className="flex gap-4">
            <a
              className="hover:text-primary transition-colors"
              href="https://github.com/atagulalan/tuval.space"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span className="sr-only">GitHub</span>
              <svg className="h-5 w-5 fill-current" viewBox="0 0 24 24">
                <path d="M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z"></path>
              </svg>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

